// extracted by mini-css-extract-plugin
export default {"containerStyles":"ProgressBar_containerStyles__AhiYB","fillerStyles":"ProgressBar_fillerStyles__cHbE8","labelStyles":"ProgressBar_labelStyles__jXSKK"};